export const TYPES = {
  SET_SETTING_WITHDRAW_ALL: "setting_withdraw/SET_SETTING_WITHDRAW_ALL",
};
